/* eslint-disable no-case-declarations */
import * as types from 'features/vehicles/importVehiclesActions';
import { REHYDRATE } from 'redux-persist';

let defaultValidationResult = {
    propesedDbActions: [],
    requests: [],
    invalidImportRequests: [],
    validImportRequests: [],
    valid: null
};

let defaultState = {
    telematicAccountType: null,
    validatingStatus: {
        validating: false,
        validationSucceeded: false,
        validationError: null
    },
    validationResult: defaultValidationResult,
    importingStatus: {
        importing: false,
        importSucceeded: false,
        importError: null
    }
};

export default function licensePlatesImports(state = defaultState, action) {
    switch (action.type) {
        case types.VALIDATE_ENTERED_LICENSE_PLATES_START:
            return {
                ...defaultState,
                validatingStatus: {
                    validating: true,
                    validationSucceeded: false,
                    validationError: null
                },
                telematicAccountType: action.payload.telematicAccountType
            };

        case types.VALIDATE_ENTERED_LICENSE_PLATES_COMPLETED:
            const validationResult = action.payload.validationResult || defaultValidationResult;
            const importRequests = validationResult.requests;
            const invalidImportRequests = importRequests.filter(importRequest => !importRequest.valid);
            const validImportRequests = importRequests.filter(importRequest => importRequest.valid);

            return {
                ...state,
                validatingStatus: {
                    validating: false,
                    validationSucceeded: true,
                    validationError: null
                },
                validationResult: {
                    ...validationResult,
                    invalidImportRequests: invalidImportRequests,
                    validImportRequests: validImportRequests
                }
            };

        case types.VALIDATE_ENTERED_LICENSE_PLATES_ERROR:
            return {
                ...state,
                validatingStatus: {
                    validating: false,
                    validationSucceeded: false,
                    validationError: action.error
                }
            };

        //------------------------------------------------------------

        case types.IMPORT_VALID_LICENSE_PLATES_START:
            return {
                ...state,
                importingStatus: {
                    importing: true,
                    importSucceeded: false,
                    importError: null
                }
            };

        case types.IMPORT_VALID_LICENSE_PLATES_COMPLETED:
            return {
                ...state,
                importingStatus: {
                    importing: false,
                    importSucceeded: true,
                    importError: null
                }
            };

        case types.IMPORT_VALID_LICENSE_PLATES_ERROR:
            return {
                ...state,
                importingStatus: {
                    importing: false,
                    importSucceeded: false,
                    importError: action.error
                }
            };

        //------------------------------------------------------------

        case types.RESET_IMPORT_STATE:
            return {
                ...defaultState
            };

        case REHYDRATE:
            return {
                ...state
            };

        default:
            return state;
    }
}
